import Backbone from 'backbone'
import _ from 'lodash'
import Tooltip from 'scoreboard/components/tooltip'
import breakdownRangeLabels from '../breakdown-range-labels'
import template from './breakdown-range-view.hbs'
import EditBreakdownRangeMenu from './edit-breakdown-range-menu'

const BreakdownRangeView = Backbone.View.extend({

	// Use the button classes to look like a button, but it will actually be a
	// list item for the drag and drop functionality.
	className: 'breakdown-range-view button button-default',

	tagName: 'li',

	/**
	 * @type ChartDesignerRange
	 */
	model: null,

	/**
	 * @type ChartDesignerBreakdown
	 */
	breakdown: null,

	/**
	 * @type ChartDesigner
	 */
	chartDesigner: null,

	/** @type {ChartData} */
	data: null,

	events: {
		'click': 'onButtonClick'
	},

	initialize: function(options = {}) {
		this.options = options
		this.breakdown = options.breakdown
		this.chartDesigner = options.chartDesigner
		this.data = options.data
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		if (this.model.get('type') === 'non-matching') {
			this.$el.addClass('is-non-matching-range')
			this.$el.toggleClass('is-disabled', !this.model.get('active'))
		}

		return this
	},

	context: function () {
		return breakdownRangeLabels({
			data: this.data,
			breakdown: this.breakdown,
			range: this.model
		})
	},

	onButtonClick: function () {
		this.removeEditTooltip()

		let editMenu = new EditBreakdownRangeMenu({
			model: this.model,
			breakdown: this.breakdown,
			chartDesigner: this.chartDesigner
		})
		this.editFieldTooltip = new Tooltip({
			attachTo: this.$el,
			content: editMenu,
			placement: 'right',
			arrow: 'top',
			extraClass: 'has-bootslide-menu chart-designer-tooltip'
		}).render()
	},

	inactive: function() {
		this.removeEditTooltip()
	},

	removeEditTooltip: function () {
		this.editFieldTooltip && this.editFieldTooltip.remove()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeEditTooltip()
	}
})

export default BreakdownRangeView

BreakdownRangeView.__filename__ = 'charts/edit/breakdown-range-view.js'
